export function createError(err) {
  return err
}
